import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "./subjectsTour.css";

export function startSubjectsPageTour() {
  const steps = [
    {
      popover: {
        title: "Hướng dẫn nhanh",
        description:
          "Tour giới thiệu các vùng chính của trang Môn học: header, bộ lọc và các nhóm trạng thái.",
        side: "over",
        align: "center",
      },
    },
  ];

  const segments = [
    {
      selector: '[data-tour="subjects-header"]',
      title: "Tiêu đề trang",
      description:
        "Hiển thị số môn học theo bộ lọc hiện tại.",
      side: "bottom",
    },
    {
      selector: '[data-tour="subjects-header-guides"]',
      title: "Cụm nút hướng dẫn",
      description:
        "Icon lấp lánh mở tour trang; icon file mở tour form; icon dấu hỏi mở hướng dẫn sử dụng HTML.",
      side: "left",
    },
    {
      selector: '[data-tour="subjects-filter"]',
      title: "Bộ lọc môn học",
      description:
        "Tìm theo tên/mã, lọc theo trạng thái và thêm môn học mới.",
      side: "bottom",
    },
    {
      selector: '[data-tour="subjects-sections"]',
      title: "Danh sách theo trạng thái",
      description:
        "Các môn học được nhóm theo Đang dạy, Nháp và Đã đóng. Bấm vào thẻ để mở chi tiết.",
      side: "top",
    },
  ];

  for (const seg of segments) {
    const el = document.querySelector(seg.selector);
    if (!el) continue;
    steps.push({
      element: el,
      popover: {
        title: seg.title,
        description: seg.description,
        side: seg.side,
      },
    });
  }

  if (steps.length <= 1) {
    window.alert("Không tìm thấy vùng để chạy hướng dẫn. Hãy tải lại trang và thử lại.");
    return;
  }

  const d = driver({
    showProgress: true,
    smoothScroll: true,
    stagePadding: 10,
    stageRadius: 14,
    overlayOpacity: 0.68,
    overlayColor: "#0f172a",
    popoverClass: "subjects-tour-popover",
    nextBtnText: "Tiếp",
    prevBtnText: "Trước",
    doneBtnText: "Xong",
    progressText: "Bước {{current}} / {{total}}",
    showButtons: ["next", "previous", "close"],
    steps,
  });

  d.drive();
}
